import { usageWarningRatio, type PlanUsage, type PlanUsageItem } from "core";
import { useOptionalAuthContext } from "../auth/useAuthContext";
import { trpc } from "./trpc";

const noUsage: PlanUsage = {
  facts: null,
  contacts: null,
  apiKeys: null,
  agentKeys: null,
  organizations: null,
  seats: null,
};

function reached(item: PlanUsageItem | null) {
  return item != null && item.used >= item.limit;
}

function aboveWarning(item: PlanUsageItem | null) {
  return item && item.used >= item.limit * usageWarningRatio ? item : null;
}

export function usePlanUsage() {
  const { user } = useOptionalAuthContext();
  const { data: usage = noUsage } = trpc.account.planUsage.useQuery(undefined, {
    enabled: user != null,
    staleTime: 60_000,
  });

  return {
    usage,
    limitsReached: {
      organizations: reached(usage.organizations),
      apiKeys: reached(usage.apiKeys),
      agentKeys: reached(usage.agentKeys),
      seats: reached(usage.seats),
    },
    warnings: {
      facts: aboveWarning(usage.facts),
      contacts: aboveWarning(usage.contacts),
      apiKeys: aboveWarning(usage.apiKeys),
      agentKeys: aboveWarning(usage.agentKeys),
    },
  };
}
